import React from "react";

function AutomateYourTrading() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Automate Your Trading with Xeer Technology</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  At Xeer Technology, our crypto trading bot solutions empower
                  you to trade smarter, faster, and more profitably. Partner
                  with us to leverage cutting-edge technology and take your
                  trading to the next level with a reliable, high-performance
                  bot tailored to your needs.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default AutomateYourTrading;
